module.exports = __webpack_public_path__ + "img/newicon2.f3883416.svg";